import React from 'react';
import './search.scss';
import { connect } from 'react-redux';
import Input from '../../../components/mweb/Input/Input';
import history from 'hb-redux-store/history';
import { getDeals } from 'hb-redux-store/feature/products/product.action';
import {
  getSearchList,
  resetPDP,
} from 'hb-redux-store/feature/products/product.action';
import Loader from '../../../components/mweb/Skeletons/Loader/Loader';
import ProductCard from '../../../components/web/ProductCard/ProductCard';
import {
  postAddItem,
  postRemoveItem,
} from 'hb-redux-store/feature/cart/cart.action';
import Button from 'components/common/Button/Button';
import Deals from 'components/web/Deals/Deals';
import AnalyticsService from 'AnalyticsService';
import { convertArrayToObject } from 'hb-redux-store/util/miscellaneousServices';
import MembershipBanner from 'components/web/MembershipBanner/MembershipBanner';
class Search extends React.Component {
  state = {
    searchKey: '',
    viewAllList: false,
  };

  componentDidMount() {
    this.props.getDeals();
  }

  searchPromise = null;

  sucessCb = (suggestions = []) => {
    const { searchKey } = this.state;
    const viewedItems = [];
    suggestions.forEach(item => {
      const [sku] = item?.skus || [];
      const analyticsItem = {
        productId: item?.productId,
        productName: item?.productName,
        category: sku?.sku ?? searchKey,
        variant: sku?.cuts ?? sku?.quantity,
        brand: item?.productName,
        price: sku?.salePrice ?? sku?.retailPrice,
      };
      viewedItems.push(analyticsItem);
    });

    // Clevertap Analytics
    const key = `View Search List`;
    const payload = {
      searchKey,
      ...convertArrayToObject(viewedItems, 'search'),
    };
    AnalyticsService.clevertap.sendCleverTapEvent(key, payload);
  };

  getSuggestion = ({ searchKey }) => {
    this.setState({ searchKey });
    if (this.searchPromise) {
      clearTimeout(this.searchPromise);
    }
    this.searchPromise = setTimeout(() => {
      console.log('Making request for list: ', searchKey);
      this.props.getSearchList(searchKey, this.sucessCb);
    }, 300);
  };

  goBack = () => {
    if (history.length === 1) {
      history.push('/');
    } else {
      history.goBack();
    }
  };

  componentWillUnmount() {
    this.props.resetPDP();
  }

  render() {
    const { deals, isLoading } = this.props;
    const { viewAllList, searchKey } = this.state;
    const { postAddItem, postRemoveItem } = this.props;
    const searchList = searchKey ? this.props.searchSuggestion : [];
    return (
      <div
        className={`desktop-search ${
          !viewAllList ? 'desktop-search--width' : ''
        }`}
      >
        <div className="desktop-search--search-container">
          {!viewAllList && (
            <div className="desktop-search--search-container--main">
              <div
                className="icon-24 icon-back-bar-back"
                onClick={this.goBack}
              ></div>
              <div className="desktop-search--search-container--width">
                <Input
                  className={`desktop-search--search-container--search-box ${
                    searchList.length
                      ? 'desktop-search-border-top '
                      : 'desktop-search-border-all '
                  }`}
                  type={'text'}
                  onChange={this.getSuggestion}
                  placeholder="Search for fruits, dry-fruits.. "
                  autoFocus
                  value={this.state.searchKey}
                  name="searchKey"
                  clearText
                  search={!this.state.searchKey.length}
                />
                <MembershipBanner source="SEARCH" />

                {searchList.length > 0 && (
                  <div
                    className={`desktop-search--search-container--search-results ${
                      searchList.length
                        ? 'desktop-search-border-bottom'
                        : 'desktop-search-border-all'
                    }`}
                  >
                    <div>
                      {isLoading && <Loader />}
                      <React.Fragment>
                        {!isLoading &&
                          searchList &&
                          searchList.slice(0, 5).map(product => (
                            <div
                              className="desktop-plp--searchlist "
                              key={product.productId}
                            >
                              <ProductCard
                                type="searchlist"
                                product={product}
                                key={product.id}
                                onIncrement={postAddItem}
                                onDecrement={postRemoveItem}
                                source="Search Listing"
                              />
                            </div>
                          ))}
                      </React.Fragment>
                      {searchList.length > 5 && (
                        <Button
                          className="desktop-plp--searchlist--button-viewall"
                          onClick={() => this.setState({ viewAllList: true })}
                        >
                          VIEW ALL RESULTS
                        </Button>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
          {/*{cartQtyCount > 0 && (
            <Link to="/cart" className="search--search-container--cart-icon">
              <span className="icon-24 icon-back-bar-cart"></span>
              <Badge text={cartQtyCount}></Badge>
            </Link>
          )}{' '}
          */}
        </div>
        <div className="desktop-search--product-container">
          {isLoading && <Loader />}
          {!isLoading && viewAllList && (
            <React.Fragment>
              {searchList.map(product => (
                <div
                  className="desktop-plp--product-card"
                  key={product.productId}
                >
                  <ProductCard
                    product={product}
                    key={product.id}
                    onIncrement={postAddItem}
                    onDecrement={postRemoveItem}
                    source="Search Listing"
                  />
                </div>
              ))}
            </React.Fragment>
          )}
        </div>
        {deals && !searchList?.length && (
          <div className="desktop-search--search-container--deals">
            <Deals
              products={deals.products}
              title={'DEALS OF THE DAY'}
              source="Search List"
            />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = ({ cartReducer, productReducer }) => ({
  cartQtyCount: cartReducer.cartQtyCount,
  deals: productReducer.deals,
  isLoading: productReducer.loadingPdp,
  searchSuggestion: productReducer.searchSuggestion,
});

const mapDispatchToProps = {
  getDeals,
  getSearchList,
  postAddItem,
  postRemoveItem,
  resetPDP,
};

export default connect(mapStateToProps, mapDispatchToProps)(Search);
